import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`timeAxis/findList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`timeAxis/findById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`timeAxis/delById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getProvince({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`timeAxis/getProvince`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  addTimeAxis({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`timeAxis/addTimeAxis`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  checkProvince({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`timeAxis/checkProvince`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateTimeAxis({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`timeAxis/updateTimeAxis`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findWebsite({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`timeAxis/findWebsite`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
